import { Anchor, AnchorProps, parseThemeColor } from '@mantine/core';

import classes from './Anchor.module.css';

const AnchorDefaults = Anchor.extend({
  classNames: {
    root: classes.root,
  },
  styles: (theme, props) => {
    const { color, isThemeColor, value } = parseThemeColor({
      // `props.c` is the color prop
      // use theme.primaryColor if no color prop is passed
      color: props.c || theme.primaryColor,
      theme,
    });

    return {
      root: {
        // if the color prop that was passed is a theme color, use the 6th shade of that color
        // otherwise, just pass the value through.
        '--anchor-theme-shade-6': isThemeColor ? theme.colors[color][6] : value,
      },
    };
  },
});

export { Anchor, AnchorDefaults };
export type { AnchorProps };
